import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { ref, onBeforeMount, onUnmounted, PropType, toRefs } from "vue";
import { IonContent, IonPage } from "@ionic/vue";
import { IPageLayout, getComputedPageLayout, getIcon } from "@/helpers/api";
import ModalMessage from "@/globals/components/ModalMessage.vue";
import { useModalManager } from "@/modules/a.worksheets/services/modalManager";
import router from "@/router";
import { useRoute } from "vue-router";
import { useWorksheetData } from "@/modules/a.worksheets/stores/worksheetDataStore";
import {
  EvaluationScale,
  Reviewer,
  useUserAnswersData,
} from "@/modules/a.worksheets/stores/wksUserAnswersDataStore";
import { useWorksheetHandler } from "@/globals/helpers/worksheetHandler";
import { useOfflineAnswerUtils } from "@/modules/k.offlineMode/1.worksheets/helpers/useAnswerUtils";
import { useDeviceStatus } from "@/stores/deviceStatus";

// const props = defineProps({
//   missingSelfReview: { type: Object as PropType<{}>}
// })
interface _1612 extends IPageLayout {
  labels: {
    title: string;
    button: string;
  };
  icons: {
    icon: string;
    button: Array<string>;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LeaveModal',
  setup(__props) {

const { isWeb } = toRefs(useDeviceStatus());

const icon = ref<string>();
const layout = getComputedPageLayout<_1612>("1612");
onBeforeMount(async () => {
  icon.value = await getIcon("1612", "icon");
});

const worksheetData = useWorksheetData();
const wh = useWorksheetHandler();
const answerStore = useUserAnswersData();
const modalManager = useModalManager();
const offlineAnswerUtils = useOfflineAnswerUtils();
const route = useRoute();
async function closeWks() {
  if (route.path === "/wks-solve" || route.path === "/worksheet") {
    router.push("/learn");
  } else {
    router.push("/offline-mode");
  }
  modalManager.close("leave");
}

function includeZeroPoints() {
  answerStore.answers.forEach((a) => {
    const open = a.answer?.open_ended;
    if (open && open.answer_assessment.length === 0) {
      console.log("including zero points: ", open);

      open.answer_assessment.push({
        who_reviewed: Reviewer.SELF,
        evaluation_scale: EvaluationScale.QUANTITATIVE,
        grade: "0",
        suffix: "points",
      });
    }
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        "force-overscroll": !_unref(isWeb)
      }, {
        default: _withCtx(() => [
          (_unref(layout))
            ? (_openBlock(), _createBlock(ModalMessage, {
                key: 0,
                icon: icon.value,
                title: _unref(layout).labels.title,
                button: { textContent: _unref(layout).labels.button, danger: true },
                onButtonClick: closeWks
              }, null, 8, ["icon", "title", "button"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["force-overscroll"])
    ]),
    _: 1
  }))
}
}

})